import {getProjectId} from "../helpers/url-params";

export const API = {
    URL: process.env.API_URL,
}

export const OAUTH =  {
    baseUrl: process.env.BASE_OAUTH_URL,
    client_id: "client_id=" + process.env.MERGADO_API_CLIENT_ID,
    redirect_uri: "redirect_uri=" + process.env.MERGADO_API_REDIRECT_URI,
    response_type: "response_type=code",
    approval_prompt: "approval_prompt=auto"
}

export const URL = {
    laravelBase: process.env.LARAVEL_BASE || process.env.PUBLIC_PATH,
    publicPath: process.env.PUBLIC_PATH,
    rootUrl: process.env.API_URL,
    websocketServer: process.env.WEBSOCKET_SERVER,
}

export const VALUES = {
    max_cpc_sk: 4,
    max_cpc_cz: 100
}

export const WEBSOCKET_SERVER = process.env.WEBSOCKET_SERVER
export const APP_ENV = process.env.APP_ENV
export const APP_MAINTENANCE_MODE = `${process.env.APP_MAINTENANCE_MODE}`
export const JWT_NAME = process.env.JWT_NAME
export const APP_NAME = process.env.APP_NAME || 'feedimageeditor'
export const GOD_MODE_ENABLED = process.env.GOD_MODE_ENABLED
export const GOD_MODE_COOKIE = process.env.GOD_MODE_COOKIE
//export const INCOGNITO_MODE_COOKIE = process.env.INCOGNITO_MODE_COOKIE
export const INCOGNITO_MODE_COOKIE = 'incognito'
export const SENTRY_DSN_JS = process.env.SENTRY_DSN_JS || ''
export const pid: number = getProjectId() ? parseInt(getProjectId()) : parseInt(sessionStorage.getItem('project_id'))
export const GTAG_ID = process.env.GTAG_ID || ''
export const REPLAY_RATIO = parseFloat(process.env.REPLAY_RATIO ?? "0")
export default {
    OAUTH: OAUTH,
    URL: URL,
    VALUES: VALUES,
    JWT_NAME: JWT_NAME,
    APP_NAME: APP_NAME,
    GOD_MODE_ENABLED,
    GOD_MODE_COOKIE,
    ENV: process.env.APP_ENV,
}